// extracted by mini-css-extract-plugin
export default {"page":"kR-z","cartModal":"lR-z","checkout":"mR-z","placeholder":"nR-z","account":"oR-z"};